export default __webpack_public_path__ + "static/media/1.d99f1143.png";